import React, { useState, useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import { Button, Grid } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import { useTranslation } from "react-i18next";

function TimeOutHOC(props) {
  const TIMOUT_VALUE = 1200000; //20 minutes (1000*60*20)
  const [isIdle, setIsIdle] = useState(false);

  const [timeUp, setTimeUp] = useState(false);
  const { t, i18n } = useTranslation("timeOutPage");

  const handleOnIdle = (event) => {
    // console.log('user is idle remaining time is ', getRemainingTime())
    // console.log('last active', getLastActiveTime())
    setIsIdle(true);
  };

  const handleOnActive = (event) => {
    // console.log('user is active', event)
    // console.log('time remaining', getRemainingTime())
    setIsIdle(false);
  };

  // const handleOnAction = event => {
  //   console.log('user did something', event)
  // }
  const {
    reset,
    pause,
    resume,
    getRemainingTime,
    getLastActiveTime,
    getElapsedTime,
  } = useIdleTimer({
    timeout: TIMOUT_VALUE,
    onActive: handleOnActive,
    onIdle: handleOnIdle,
    //  onAction : handleOnAction
  });

  useEffect(() => {
    if (!isIdle) {
    } else {
      setTimeUp(true);
    }
  }, [isIdle]);

  return (
    <div>
      {!timeUp ? (
        <>{props.children}</>
      ) : (
        <Dialog open={true}>
          <DialogTitle>{t("heading")}</DialogTitle>
          <DialogContent>
            <Grid container alignItems="center" justify="center">
              <Grid item md={2} justify="center">
                <ReportProblemOutlinedIcon
                  style={{ fontSize: 60, color: "#ffb74d" }}
                />
              </Grid>
              <Grid item md={10}>
                <DialogContentText color="textPrimary">
                  {t("content")}
                </DialogContentText>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() =>
                (window.location.href = process.env.REACT_APP_BASE_URL)
              }
              color="primary"
            >
              {t("btnProceed")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}

export default TimeOutHOC;
